import { render } from "./TableSchema.vue?vue&type=template&id=37563498&scoped=true"
import script from "./TableSchema.vue?vue&type=script&lang=js"
export * from "./TableSchema.vue?vue&type=script&lang=js"

import "./TableSchema.vue?vue&type=style&index=0&id=37563498&scoped=true&lang=scss"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37563498"]])

export default __exports__